<template>
    <v-btn :class="[baseClass, { 'PrimaryButton': isPrimary, 'active': isActive, 'disabled': disabled }, buttonClass]"
        :disabled="disabled" elevation="0" @click="handleClick" :x-small="xsmall" :small="small" :style="{ backgroundColor: backColor, width: width }">

        <template v-if="icon">
            <v-icon class="mr-1" style="font-size: 16px;" :color="iconColor">{{ icon }}</v-icon>
        </template>

        {{ buttonText }}
    </v-btn>
</template>

<script>
export default {
    name: 'TextButton',
    props: {
        width: String,
        buttonText: {
            type: String,
            default: 'Save'
        },
        icon: {
            type: String,
            default: ''
        },
        Black: {
            type: Boolean,
            default: false
        },
        iconColor: {
            type: String,
            default: '#fff'
        },
        isPrimary: {
            type: Boolean,
            default: false
        },
        buttonClass: {
            type: String,
            default: 'TextButton'
        },
        buttonClick: {
            type: Function,
        },
        disabled: {
            type: Boolean,
            default: false
        },
        xsmall: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        isActive: {
            type: Boolean,
            default: false
        },
        backColor: {
            type: String,
            default: 'white' // 기본값은 흰색으로 설정
        },
    },
    computed: {
        baseClass() {
            return this.isPrimary ? 'PrimaryButton' : 'TextButton';
        }
    },
    methods: {
        handleClick() {
            this.$emit('click');
        }
    }
};
</script>

<style scoped>
.TextButton {
    background: #fff !important;
    border: 1px solid #bbb;
}

.PrimaryButton {
    background: #007bff !important;
    color: #fff;
}

.BlackButton {
    background: #000 !important;
    color: #fff;
}

.active {
    background: #007bff !important;
    color: white !important;
}

/* active 스타일 추가 */
.disabled {
    background: #ccc !important;
    color: #ff0000 !important;
    cursor: not-allowed;
}

/* disabled 스타일 추가 */
</style>